import type { DeliveryCard } from "@/components/landing/Delivery/types";
import type { GlyphName } from "@/components/landing/shared";
import { Glyph } from "@/components/landing/shared";

interface DeliveryInfoGridProps {
	card: DeliveryCard;
}

function DeliveryInfoGrid(prop: DeliveryInfoGridProps) {
	const { card } = prop;
	const rows: { icon: GlyphName; label: string; value: string }[] = [
		{ icon: "person", label: card.courierLabel, value: card.courierName },
		{ icon: "pin", label: card.addressLabel, value: card.addressValue },
		{ icon: "clock", label: card.etaLabel, value: card.etaValue },
	];

	return (
		<div className="mt-10 grid gap-6 border-t border-border pt-6 sm:grid-cols-3">
			{rows.map((row) => (
				<div key={row.label} className="flex items-center gap-3">
					<Glyph name={row.icon} className="h-5 w-5 shrink-0 text-[var(--brand-2)]" />
					<div>
						<p className="text-xs text-muted-foreground">{row.label}</p>
						<p className="font-semibold">{row.value}</p>
					</div>
				</div>
			))}
		</div>
	);
}

export default DeliveryInfoGrid;
